import { createClient } from "@smfa/utils";
import { createAction, createFileUploadAction } from "./home.actions";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;

const axios = createClient({ baseUrl, isAdminSite: true });

// Banner actions
export const addCommunityfinanceBanner = createFileUploadAction(
  "/add_edit_commitee_finance_banner",
);
export const addCommunityfinance = createFileUploadAction(
  "/add_edit_community_finance_membership",
);

// Committee members actions
export const addCommunityfinanceMemberList = createFileUploadAction(
  "/add_edit_community_finance_member_list",
);
export const getCommunityfinanceMemberList = createAction(
  "/get_community_finance_member_list",
);
export const deleteCommunityfinanceMember = createAction(
  "/delete_community_finance_member",
);

// Affiliates actions
export const addEditAffiliatesBanner = createFileUploadAction(
  "/add_edit_affiliates_banner",
);
export const addEditAffiliates = createFileUploadAction("/add_edit_affiliates");
export const deleteAffiliates = createAction("/delete_affiliates");

// Committee Education actions
export const addCommunityEducationBanner = createFileUploadAction(
  "/add_edit_community_education_banner",
);
export const addCommunityEducation = createFileUploadAction(
  "/add_edit_community_education",
);
export const getCommunityEducationMembers = createAction(
  "/list_community_education_member",
);

// Export these functions for use in components

export const addCommunityBanner = (data) => {
  return axios.post("/add_edit_community_banner", data);
};

export const getCommunityBanner = (data) => {
  return axios.post("/get_community_banner", data);
};

export const addCommunityPlanning = (data) => {
  return axios.post("/add_edit_community_planning", data);
};

export const getCommunityPlanning = (data) => {
  return axios.post("/get_community_planning", data);
};

export const getCommunityfinanceBanner = (data) => {
  return axios.post("/get_commiitee_finance_banner", data);
};

export const addCommunityresearchBanner = (data) => {
  return axios.post("/add_edit_community_research_banner", data);
};

export const getCommunityresearchBanner = (data) => {
  return axios.post("/get_community_research_banner", data);
};

export const addCommunityresearch = (data) => {
  return axios.post("/add_edit_community_research_membership", data);
};

export const getCommunityresearch = (data) => {
  return axios.post("/get_community_research_membership", data);
};

export const addCommunityintersocietyBanner = (data) => {
  return axios.post("/add_edit_community_intersociety_banner", data);
};

export const getCommunityintersocietyBanner = (data) => {
  return axios.post("/get_community_intersociety_banner", data);
};

export const addCommunityintersociety = (data) => {
  return axios.post("/add_edit_community_Intersociety", data);
};

export const getCommunityintersociety = (data) => {
  return axios.post("/get_community_intersociety", data);
};

export const addCommunitymember = (data) => {
  return axios.post("/add_edit_community_member", data);
};

export const getCommunitymember = (data) => {
  return axios.post("/list_community_member", data);
};

export const deleteCommitteeMember = (data) => {
  return axios.post(`/delete_communitymember`, data);
};
